import axios from 'axios'
import type { AxiosError } from 'axios'
import { FetchError } from 'ofetch'
import type { ApiErrorResponse } from './YscApiError'

export const isAxiosError = axios.isAxiosError
export const isOFetchError = (error: Error) => error instanceof FetchError

export type RawApiError = AxiosError | FetchError

export const isRawApiError = (error: Error): error is RawApiError => isAxiosError(error) || isOFetchError(error)

// TODO: clean available data when axios is removed
export type RawApiErrorData = {
  apiStatus: number
  apiMethod: string | undefined
  apiURL: string | undefined
  apiEndpoint: string | undefined
  apiResponseErrorData: ApiErrorResponse
  apiPayloadData: unknown | undefined
  apiParamsData: unknown | undefined
}

export const getRawApiErrorData = (error: RawApiError): RawApiErrorData | undefined => {
  if (!isDefined(error.response)) {
    return undefined
  }

  if (isAxiosError(error)) {
    return {
      apiStatus: error.response.status,
      apiMethod: error.response.config.method,
      apiURL: error.response.config.baseURL,
      apiEndpoint: error.response.config.url,
      apiParamsData: error.response.config.params,
      apiPayloadData: error.response.config.data,
      apiResponseErrorData: error.response.data as ApiErrorResponse, // Force cast and trust the api doesn't magically invent a new error response type
    }
  }

  const requestUrl = new URL(error.response.url)
  return {
    apiStatus: error.response.status,
    apiMethod: error.options?.method,
    apiURL: requestUrl.origin,
    apiEndpoint: requestUrl.pathname,
    apiParamsData: requestUrl.searchParams,
    apiPayloadData: error.options?.body,
    apiResponseErrorData: error.data as ApiErrorResponse, // Force cast and trust the api doesn't magically invent a new error response type,
  }
}
